import { SettingsMap } from '../dashboardSettingsTypes';

export const SETTINGS_MAP = {
  companyDetails: {
    label: 'Company Details',
    components: {
      name: {
        label: 'Name',
        fieldName: 'name',
        fieldType: 'string',
        tooltip: '',
      },
      partner: {
        label: 'Lead Partner',
        fieldName: 'partner',
        fieldType: 'string',
      },
      ceo: {
        label: 'CEO',
        fieldName: 'ceoName',
        fieldType: 'string',
      },
      foundingDate: {
        label: 'Founding Date',
        fieldName: 'foundingDate',
        fieldType: 'date',
      },
      website: {
        label: 'Website',
        fieldName: 'url',
        fieldType: 'string',
      },
      initialInvestmentDate: {
        label: 'Initial Investment Date',
        fieldName: 'investmentDate',
        fieldType: 'date',
      },
      address: {
        label: 'Address',
        fieldName: 'fullAddress',
        fieldType: 'string',
      },
      sector: {
        label: 'Sector',
        fieldName: 'sector.name',
        fieldType: 'string',
      },
    }
  },
  description: {
    label: 'Description',
    components: {}
  },
  ownershipMetrics: {
    label: 'Ownership Metrics',
    components: {
      ownership: {
        label: 'Ownership',
        fieldName: 'ownershipPercent',
        fieldType: 'percentage2',
        tooltip: 'The Fund\'s holdings percentage in the portfolio company, on a fully diluted basis',
      },
      cost: {
        label: 'Cost',
        fieldName: 'investedCapital',
        fieldType: 'currency0',
        tooltip: 'Sum of Investments made by the fund in the portfolio company',
      },
      irr: {
        label: 'IRR',
        fieldName: 'irr',
        fieldType: '100percentage2',
        tooltip: 'IRR of the fund’s investment in the portfolio company, as calculated by EE Invest Cap Table Waterfall; based on the investments of the fund in the portfolio company, the Realized Value and the NAV',
      },
      minEv: {
        label: 'Lowest EV',
        fieldName: 'minEv',
        fieldType: 'currency0',
        tooltip: 'EV is determined by the PPS of the latest financing round multiplied by the # of fully diluted shares in the cap table',
      },
      maxEv: {
        label: 'Highest EV',
        fieldName: 'maxEv',
        fieldType: 'currency0',
        tooltip: 'EV is determined by the PPS of the latest financing round multiplied by the # of fully diluted shares in the cap table',
      },
      nav: {
        label: 'NAV',
        fieldName: 'nav',
        fieldType: 'currency0',
        tooltip: 'NAV is determined by EE Invest based on the Waterfall output of the fund’s investment in the portfolio company; taking into account liquidation preferences, anti dilution provisions and similar investments and terms of co-investors',
      },
      realizedValue: {
        label: 'Realized Value',
        fieldName: 'realizedValue',
        fieldType: 'currency0',
        tooltip: 'The sum of the realized value received by the Fund from its investments in the portfolio company',
      },
      totalValue: {
        label: 'Total Value',
        fieldName: 'totalValue',
        fieldType: 'currency0',
        tooltip: 'Sum of NAV and Realized Value',
      },
      multiple: {
        label: 'Multiple',
        fieldName: 'multiple',
        fieldType: 'decimal2',
        tooltip: 'NAV and Realized Value, divided by the Cost',
      },
    }
  },
  companyUpdate: {
    label: 'Company Update',
    components: {}
  },
  sentiment: {
    label: 'Quarterly Sentiment',
    components: {}
  },
  fundRaisingSummary: {
    label: 'Fund Raising Summary',
    components: {
      name: {
        label: 'Name',
        fieldName: 'name',
        fieldType: 'string',
        tooltip: '',
      },
      date: {
        label: 'Date',
        fieldName: 'transactionDate',
        fieldType: 'date',
      },
      pps: {
        label: 'PPS',
        fieldName: 'price',
        fieldType: 'currency4',
      },
      fundParticipated: {
        label: 'Fund Participated',
        aggr_label: 'Fund(s) Participated',
        fieldName: 'fundParticipated',
        fieldType: 'boolean',
      },
      preMoney: {
        label: 'Pre-Money',
        fieldName: 'premoneyValuation',
        fieldType: 'currency0',
      },
      totalRaised: {
        label: 'Total Raised',
        fieldName: 'totalRaised',
        fieldType: 'currency0',
      },
      postMoney: {
        label: 'Post Money',
        fieldName: 'companyValuation',
        fieldType: 'currency0',
      },
      cost: {
        label: 'Cost',
        fieldName: 'amount',
        fieldType: 'currency0',
      },
      fd: {
        label: 'FD%',
        fieldName: 'equityDilution',
        fieldType: 'percentage2',
      },
      fundOutstandingShares: {
        label: 'Fund Outstanding Shares',
        aggr_label: 'Fund(s) Outstanding Shares',
        fieldName: 'sharesPurchased',
        fieldType: 'integer',
      },
      liquidationPreference: {
        label: 'Liquidation Preference',
        fieldName: 'liquidationPreference',
        fieldType: 'string',
      },
      leadInvestor: {
        label: 'Lead Investor',
        fieldName: 'leadInvestor',
        fieldType: 'string',
      },
      multiple: {
        label: 'Multiple',
        fieldName: 'multiple',
        fieldType: 'ratio2',
      },
      irr: {
        label: 'IRR',
        fieldName: 'irr',
        fieldType: 'percentage2',
      },
    }
  },
  topInvestors: {
    label: 'Top Investors',
    components: {},
  },
  kpis: {
    label: 'KPIs',
    'components': {},
  },
  clonedVersions: {
    label: 'Cloned Versions',
    components: {},
  },
} as SettingsMap
